import { getExploreCategories } from '../../../data/repositories/businessRepository.js';

export const fetchExploreCategories = () => getExploreCategories();
